import * as React from 'react';
import { useForm } from 'react-hook-form';
import Dialog from 'src/components/common/Dialog';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

export interface IBuildSingleManagerReviewParams {
    mgrNo: number;
}

interface IBuildSingleManagerReviewDialogProps {
    dialogName: string;
    hideDialog: () => void;
    onSubmit: (params: IBuildSingleManagerReviewParams) => void;
    message?: string;
}

// Mirrors the SINGLE block/window - just TSD_NO + OK/Cancel, per the real screenshot.
const BuildSingleManagerReviewDialog = (props: IBuildSingleManagerReviewDialogProps) => {
    const { register, errors, getValues, reset } = useForm();

    const handleOk = () => {
        const values = getValues();
        if (!values.tsdNo) {
            return;
        }
        props.onSubmit({ mgrNo: Number(values.tsdNo) });
        reset();
    };

    const handleCancel = () => {
        reset();
        props.hideDialog();
    };

    return (
        <Dialog title="Build Single Manager Review" dialogName={props.dialogName} isExitButtonInvisible={true} bodyStyle={{ width: '26%' }}>
            <form>
                <div className="form-row" style={{ alignItems: 'center', flexWrap: 'nowrap' }}>
                    <label style={{ whiteSpace: 'nowrap', marginRight: '.5rem' }}>Enter Manager/Crew Chief No.</label>
                    <RHFInputBox name="tsdNo" type="number" register={register} errors={errors} style={{ width: '100%' }} />
                </div>
            </form>
            <div className="form-row" style={{ marginTop: '1.5rem', justifyContent: 'center' }}>
                <Button className="blue-hover-button" style={{ width: '25%', marginRight: '1rem' }} text="OK" onClick={handleOk} />
                <Button className="blue-hover-button" style={{ width: '25%' }} text="Cancel" onClick={handleCancel} />
            </div>
            {!!props.message && (
                <div style={{ marginTop: '1rem', minHeight: '1.2rem', textAlign: 'center', color: 'red' }}>{props.message}</div>
            )}
        </Dialog>
    );
};

export default BuildSingleManagerReviewDialog;



// WEBPACK FOOTER //
// ./src/components/personnel/dialogs/BuildSingleManagerReviewDialog.tsx